import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { UsuarioWidget } from '../_models/usuario-widget';
@Injectable({
  providedIn: 'root'
})
export class UsuarioWidgetService {
  private masterService = AppSettings.rutServiciosASI + '/api/usuariosWidgets/';


  constructor( private authHttp: HttpClient, private autServicio: AutenticacionService ) {
  }

  getAll() {
    return this.authHttp.get( this.masterService )
      .pipe(map( res => res as UsuarioWidget[] ));
  }

  getById( id: string ) {
    return this.authHttp.get( this.masterService + id ).pipe(map( res => res as UsuarioWidget ));
  }

  add( c: UsuarioWidget ) {
    c.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.authHttp.post( this.masterService, c ).pipe(map( res => res as UsuarioWidget ));
  }

  update( f: UsuarioWidget ) {
    f.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.authHttp.put( this.masterService, f ).pipe(map( res => res as UsuarioWidget ));
  }

  getByUser( user: string ) {
    return this.authHttp.get( this.masterService + 'usuario/' + user )
      .pipe(map( res => res as UsuarioWidget[] ));
  }
}
